import styled from "styled-components"
import React from "react"
import { PlusIcon, MinusIcon } from "client/components"


export const ModelWrapper = styled.div<{
    direction: "row" | "column"
}>`
    display: flex;
    flex-direction: ${(props) => props.direction};
    width: 100%;
    padding: 10px;
    overflow-x: scroll;
    background: ${(props) => props.theme.silModelWrapperBackground};
`
export const ModelNestedWrapper = styled.div` // for wrapping safety function model and subsystem settings
    display: flex;
    flex-direction: row;
    width: 100%;
`
export const BlockWrapper = styled.div<{
    type: "subsystem" | "function"
}>`
    position: relative;
    display: flex;
    flex-direction: column;
    height: fit-content;
    width: ${(props) => (props.type === "subsystem" ? "150px" : "226px")};
    align-items: center;
    margin: 20px 20px 35px 20px;
    padding: 15px;
    border: 1px dashed ${(props) => props.theme.silModelBlockWrapperBorderColor};
`
export const Block = styled.div`
    position: relative;
    height: 102px;
    width: 102px;
    margin: 8px;
    border: 1px solid #ececec;
`
export const BlockInputWrapper = styled.div`
    display: flex;
    flex-direction: column;
`
export const ChangeButton = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: ${(props) => props.theme.openSans};
    font-weight: 600;
    background: ${(props) => props.theme.silModelChangeButtonBackground};
    opacity: 0;
    user-select: none;
    transition: ${(props) => props.theme.defaultTransition};
    
    &:hover {
        opacity: 1;
        transition: ${(props) => props.theme.defaultTransition};
    }
`
export const ModelSil = styled.span`
    transform: translateY(-6px);
    font-weight: 600;
    font-family: ${(props) => props.theme.openSans};
`


export const AddButtonWrapper = styled.div`
    height: fit-content;
    padding: 20px 10px;
    color: ${(props) => props.theme.silModelButtonColor};
    
    &:hover {
        color: ${(props) => props.theme.silModelButtonHoverColor};
    }
`
export const AddButton = (props: React.HTMLAttributes<HTMLDivElement>) => (
    <AddButtonWrapper {...props}>
        <PlusIcon />
    </AddButtonWrapper>
)


export const RemoveButtonWrapper = styled.div`
    position: absolute;
    width: 100%;
    top: 100%;
    left: 0;
    padding: 6px;
    text-align: center;
    color: ${(props) => props.theme.silModelButtonColor};
    
    &:hover {
        color: ${(props) => props.theme.silModelButtonHoverColor};
    }
`
export const RemoveButton = (props: React.HTMLAttributes<HTMLDivElement>) => (
    <RemoveButtonWrapper {...props}>
        <MinusIcon />
    </RemoveButtonWrapper>
)


export const SettingsWrapper = styled.div<{
    viewMode?: boolean
}>`
    display: flex;
    flex-direction: column;
    width: 226px;
    height: fit-content;
    margin: 20px 20px 35px ${(props) => (props.viewMode ? "20px" : "51px")};
    padding: 15px;
    border: 1px dashed ${(props) => props.theme.silModelBlockWrapperBorderColor};
`
export const SettingsTitle = styled.span`
    margin-bottom: 10px;
    min-height: 21px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-family: ${(props) => props.theme.openSans};
    font-weight: 600;
`
